module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["设置"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right orange",
    on: {
      "click": function($event) {
        _vm.updateTeacher()
      }
    }
  }, ["保存"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page class-edit"
  }, [_vm._h('div', [_vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt upload-pic",
    staticStyle: {
      "height": "60px",
      "line-height": "60px"
    }
  }, [_vm._h('form', {
    staticClass: "clearfix",
    attrs: {
      "enctype": "multipart/form-data",
      "method": "post",
      "name": "fileinfo"
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["设置头像："]), " ", _vm._h('div', {
    staticClass: "pull-right img-wrap big",
    staticStyle: {
      "z-index": "1"
    }
  }, [_vm._h('img', {
    attrs: {
      "src": _vm.imageAddress ? _vm.baseAcessPath + _vm.imageAddress : _vm.img_default
    }
  })]), " ", (_vm.isAndroid) ? _vm._h('span', {
    staticClass: "upload-wrap",
    on: {
      "click": function($event) {
        _vm.capturePhoto();
      }
    }
  }) : _vm._h('span', {
    staticClass: "upload-wrap"
  }, [_vm._h('input', {
    attrs: {
      "type": "file",
      "name": "pic",
      "id": "pic",
      "accept": "image/*",
      "size": "1"
    },
    on: {
      "change": function($event) {
        _vm.updateImage()
      }
    }
  })]), " "])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["姓名："]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teacherName),
      expression: "teacherName"
    }],
    staticClass: "text-right font-14",
    attrs: {
      "type": "text",
      "placeholder": "您的真实姓名"
    },
    domProps: {
      "value": _vm._s(_vm.teacherName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teacherName = $event.target.value
      }
    }
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('router-link', {
    staticClass: "clearfix group-txt img-more",
    attrs: {
      "to": {
        'path': '/user/center/updPhone'
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["手机号码："]), " ", _vm._h('span', {
    staticClass: "pull-right gray margin-x-15 font-14"
  }, [_vm._s(_vm.phoneNum)])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('router-link', {
    staticClass: "clearfix  group-txt img-more",
    attrs: {
      "to": {
        'path': '/user/center/about'
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["关于少儿之家："]), " ", _vm._h('span', {
    staticClass: "pull-right gray  margin-x-15"
  }, ["园点端 v2.0"])])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('a', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reload()
      }
    }
  }, [_vm._h('span', {
    staticClass: "block text-center"
  }, ["清除缓存"])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.popupvisebleSetting = true
      }
    }
  }, [_vm._h('span', {
    staticClass: "block text-center"
  }, ["退出登录"])])])])])]), " ", _vm._h('mt-popup', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupvisebleSetting),
      expression: "popupvisebleSetting"
    }],
    attrs: {
      "position": "bottom"
    },
    domProps: {
      "value": (_vm.popupvisebleSetting)
    },
    on: {
      "input": function($event) {
        _vm.popupvisebleSetting = $event
      }
    }
  }, [_vm._h('div', {
    staticClass: "text-center"
  }, [_vm._h('ul', {
    staticClass: "list-group-item  tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('p', {
    staticClass: "gray padding-15"
  }, ["退出登录后不会删除任何历史数据，下次登录依然可以使用本账号"])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._h('span', {
    staticClass: "orange block font-16"
  }, ["退出"])])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.popupvisebleSetting = false
      }
    }
  }, [_vm._h('span', {
    staticClass: "block font-16"
  }, ["取消"])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-5202cb90!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userCollection/Settings.vue
// module id = 203
// module chunks = 1